<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import WebAppIframe from './components/WebAppIframe.vue';
import { updateServiceWorker } from '@/utils/app/registerServiceWorker';
import { useTranslator } from '@/composables/useTranslator';
import { eventBus } from '@/utils/core/eventBus';
const t = useTranslator();
const showUpdateSnackbar = ref(false);
let pendingUpdate = false;
let externisReady = false;

function onUpdateAvailable() {
	if (externisReady) {
		// showUpdateSnackbar.value = true;
	} else {
		pendingUpdate = true;
	}
}

function onExternisReady() {
	externisReady = true;
	if (pendingUpdate) {
		// showUpdateSnackbar.value = true;
		pendingUpdate = false;
	}
}

function confirmUpdate() {
	showUpdateSnackbar.value = false;
	updateServiceWorker();
}

onMounted(() => {
	window.addEventListener('sw-update-available', onUpdateAvailable);
	eventBus.on('externis-ready', onExternisReady);
});

onUnmounted(() => {
	window.removeEventListener('sw-update-available', onUpdateAvailable);
	eventBus.off('externis-ready', onExternisReady);
});
</script>

<template>
	<WebAppIframe ref="iframeRef" />
	<v-snackbar v-model="showUpdateSnackbar" :timeout="-1" location="bottom" rounded="xl">
		{{ t('New version available. Please refresh the page.') }}
		<template #actions>
			<v-btn variant="text" @click="showUpdateSnackbar = false">{{ t('Close') }}</v-btn>
			<v-btn color="primary" variant="text" @click="confirmUpdate">{{ t('Update') }}</v-btn>
		</template>
	</v-snackbar>
</template>
